import { useEffect, useRef } from "react";
import CloseIcon from "../../assets/icons/close-2hite.svg";
import "./CommonModal.css";

const CommonModal = ({
  openRef,
  closeRef,
  id,
  modalHeadText,
  hideCloseButton,
  content,
  disabled,
  size = "sm",
  onModalClose = () => {},
  isFullScreen = false,
  headerTextAlign = "center",
  headerSpacing,
  backDrop = true,
  modalStyle = {},
  modalBodyStyle = {},
  outSideCloseButton = false,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById(id);
    if (!modalEl) return;
    modalRef.current = modalEl;
    const handleHidden = () => {
      onModalClose();
    };
    modalEl.addEventListener("hidden.bs.modal", handleHidden);
    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleHidden);
    };
  }, [id, onModalClose]);

  return (
    <>
      <button
        type="button"
        className="hidden"
        data-bs-toggle="modal"
        data-bs-target={`#${id}`}
        ref={openRef}
      ></button>

      <div
        className="modal fade"
        id={id}
        data-bs-backdrop={backDrop ? "static" : "true"}
        data-bs-keyboard="true"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div
          className={`modal-dialog ${
            isFullScreen ? "modal-fullscreen" : "modal-dialog-centered"
          } modal-${size} position-relative`}
        >
          <div
            className={`modal-content ${
              isFullScreen ? "bg-transparent" : "bg-white"
            }`}
            style={{
              ...modalStyle,
              textAlign: headerTextAlign || "center",
            }}
          >
            {(modalHeadText || !hideCloseButton) && (
              <div className={`modal-header ${headerSpacing || ""}`}>
                {modalHeadText && (
                  <div className="modal-head-text">{modalHeadText}</div>
                )}

                <button
                  type="button"
                  className="p-1 text-gray-500 hover:text-gray-700"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  ref={closeRef}
                  style={{ display: hideCloseButton ? "none" : "block" }}
                  disabled={disabled}
                ></button>
              </div>
            )}

            <div className="modal-body" style={modalBodyStyle}>
              {content}
            </div>
          </div>
        </div>

        {outSideCloseButton && (
          <div
            className="outside-btn-wrap"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref={closeRef}
            onClick={() => onModalClose()}
          >
            <img src={CloseIcon} alt="" />
            <div className="esc-wrap">Esc</div>
          </div>
        )}
      </div>
    </>
  );
};

export default CommonModal;
